import React, { useEffect, useState } from "react";
import { CommonUtilities } from "../../../commonUtils";
import Header from "../../Header/header";
import { Modal } from 'react-responsive-modal';
import ViewUploadFileLogBox from "./ViewUploadFileLog";





export default function Amazon(subEntity: any) {

    const [showtab, setShowTab] = useState(false);
    const [loop, setloop] = useState(1);
    let [activeMenu, setActiveMenu] = useState("Amazon");
    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)
    }

    let [checkAmazonData, setCheckAmazonData] = useState(false);



    let [checkInvData, setCheckInvData] = useState(false);
    let [checkInvNoDate, setCheckInvNoDate] = useState(false);
    let [exportAmazonData, setExportAmazonData] = useState(false);
    let [dataDeleted, setDataDeleted] = useState(false);

    let [fileUploadHistoryStatus, setFileUploadHistoryStatus] = useState(false);
    const viewUploadHistory = () => {
        setFileUploadHistoryStatus(true)
    }

    const ViewUploadFileLogClose = () => {
        fileUploadHistoryStatus = false
        setFileUploadHistoryStatus(false)
    }



    let [collapsedGetReport, setcollapsedGetReport] = useState(false);
    let [collapsedCheckReport, setcollapsedCheckReport] = useState(false);


    
    

    return (

        <div className="ws-12 pm">

            <div className="ws-12">
                <div className="box">
                    <div className="box-header well p0 pt prs">
                        <h2 className="ws-12 m0 pl full-width"><i className="icon-file-add"></i> Get Report
                            <button className="icon-btn info pull-right m2" onClick={() => setcollapsedGetReport(!collapsedGetReport)}>
                                <i className={collapsedGetReport ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                            </button>
                            {collapsedGetReport && <>
                            <button title="File Upload History" className="btn-xxs pull-right icon-btn info"  ng-className="(statusFile == 0) ? 'icon-btn info' : 'btn-warning'" onClick={() => viewUploadHistory()}><i className="icon-history"></i> </button>
                            </>}
                        </h2>
                    </div>
                    {collapsedGetReport && <>
                    <div className="box-content" data-ng-hide="getReportDsply">
                        {
                            checkAmazonData && <div className="alert alert-info">Please select a month, a report and a territory</div>
                        }
                        {
                            checkAmazonData && <div className="alert alert-info">Generation of Report(s) in process</div>
                        }
                        {
                            checkAmazonData && <div className="alert alert-info">Data has been uploaded succesffuly</div>
                        }
                        {
                            checkAmazonData && <div className="alert alert-info">An error has occur, please check file status for more details</div>
                        }
                        <form  >

                            <div className="ws-12">
                                <div className="ws-6">
                                    <label className="control-label pull-left " >  Upload File</label>
                                    <label className="btn icon-btn edit btn-file btn-sm">
                                        <i className="icon-upload"></i>
                                        <input type="file"/>
                                    </label>
                                </div>

                                <div className="ws-6">
                                    <div className="form-format">
                                        <div className="progress">
                                            <div className="progress-bar ">
                                                %
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>

                    </div >
                    <div className="box-footer" data-ng-hide="getReportDsply">
                        <a className="icon-btn info  " data-ng-hide="showLoad" data-ng-click="loadFile(searchDate, selectTerritory)">
                            <i className="icon-upload"></i> Load
                        </a>
                    </div>
                    </>}
                </div>

                <div className="box mts">
                    <div className="box-header well p0 pt prs">
                        <h2 className="ws-12 m0 pl full-width"><i className="icon-file-add"></i> Check Report
                            <button className="icon-btn info pull-right m2" onClick={() => setcollapsedCheckReport(!collapsedCheckReport)}>
                                <i className={collapsedCheckReport ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                            </button>
                        </h2>
                    </div>
                    {collapsedCheckReport && <>
                    <div className="box-content " data-ng-hide="getChkReportDsply">
                        <div className="mbl row-fluid">

                            <form name="frmCheckReport" >
                                <div className="ws-3">
                                    <div className="form-format">
                                        <label className="control-label">Date</label>
                                        <div className="label-entries">
                                            <input type="text" placeholder="Select month and year"  data-ng-click="open($event,'checkDate')"  data-ng-model="checkDate" is-open="datepickers.checkDate" readOnly id="checkDate" name="checkDate" />
                                        </div>
                                    </div>
                                </div>
                                <div className="ws-3">
                                    <div className="form-format">
                                        <label className="control-label">Report</label>
                                        <div className="label-entries">
                                            <select data-ng-model="selectReport"  >
                                                <option value="" data-ng-selected="true" selected>Choose a report</option>
                                                <option  value="Cloud" >Cloud Report</option><option  value="MP3" >MP3</option><option  value="Prime" >Prime Report</option><option  value="Unlimited" >Unlimited Report</option><option  value="ADS" >ADS Usage</option><option  value="AMU" >AMU Usage</option><option  value="PrimeUsage" >Prime Usage</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="ws-3">
                                    <div className="form-format">
                                        <label className="control-label">Territory</label>
                                        <div className="label-entries">
                                            <select data-ng-model="selectTerritory"  >
                                                <option value="" >Choose a territory</option>
                                                <option value="All" selected >All</option>
                                                <option data-ng-repeat="t in territories" value="AU" >Australia (AU)</option><option data-ng-repeat="t in territories" value="BR" >Brazil (BR)</option><option data-ng-repeat="t in territories" value="BG" >Bulgaria (BG)</option><option data-ng-repeat="t in territories" value="CA" >Canada (CA)</option><option data-ng-repeat="t in territories" value="CL" >Chile (CL)</option><option data-ng-repeat="t in territories" value="CN" >China (CN)</option><option data-ng-repeat="t in territories" value="CO" >Colombia (CO)</option><option data-ng-repeat="t in territories" value="HR" >Croatia (HR)</option><option data-ng-repeat="t in territories" value="CZ" >Czech Republic (CZ)</option><option data-ng-repeat="t in territories" value="DK" >Denmark (DK)</option><option data-ng-repeat="t in territories" value="EG" >Egypt (EG)</option><option data-ng-repeat="t in territories" value="EU" >Euro-Zone (EU)</option><option data-ng-repeat="t in territories" value="HK" >Hong Kong (HK)</option><option data-ng-repeat="t in territories" value="HU" >Hungary (HU)</option><option data-ng-repeat="t in territories" value="IN" >India (IN)</option><option data-ng-repeat="t in territories" value="ID" >Indonesia (ID)</option><option data-ng-repeat="t in territories" value="IL" >Israel (IL)</option><option data-ng-repeat="t in territories" value="JP" >Japan (JP)</option><option data-ng-repeat="t in territories" value="KZ" >Kazakhstan (KZ)</option><option data-ng-repeat="t in territories" value="LL" >Latin America and the Caribbean (LL)</option><option data-ng-repeat="t in territories" value="MY" >Malaysia (MY)</option><option data-ng-repeat="t in territories" value="MX" >Mexico (MX)</option><option data-ng-repeat="t in territories" value="NZ" >New Zealand (NZ)</option><option data-ng-repeat="t in territories" value="NG" >Nigeria (NG)</option><option data-ng-repeat="t in territories" value="NO" >Norway (NO)</option><option data-ng-repeat="t in territories" value="PE" >Peru (PE)</option><option data-ng-repeat="t in territories" value="PH" >Philippines (PH)</option><option data-ng-repeat="t in territories" value="PL" >Poland (PL)</option><option data-ng-repeat="t in territories" value="QA" >Qatar (QA)</option><option data-ng-repeat="t in territories" value="KR" >Republic of Korea (KR)</option><option data-ng-repeat="t in territories" value="WW" >Rest of World (WW)</option><option data-ng-repeat="t in territories" value="RO" >Romania (RO)</option><option data-ng-repeat="t in territories" value="RU" >Russia (RU)</option><option data-ng-repeat="t in territories" value="SA" >Saudi Arabia (SA)</option><option data-ng-repeat="t in territories" value="SG" >Singapore (SG)</option><option data-ng-repeat="t in territories" value="ZA" >South Africa (ZA)</option><option data-ng-repeat="t in territories" value="AP" >South Asia and Pacific (AP)</option><option data-ng-repeat="t in territories" value="SE" >Sweden (SE)</option><option data-ng-repeat="t in territories" value="CH" >Switzerland (CH)</option><option data-ng-repeat="t in territories" value="TW" >Taiwan (TW)</option><option data-ng-repeat="t in territories" value="TH" >Thailand (TH)</option><option data-ng-repeat="t in territories" value="TR" >Turkey (TR)</option><option data-ng-repeat="t in territories" value="AE" >United Arab Emirates (AE)</option><option data-ng-repeat="t in territories" value="GB" >United Kingdom (GB)</option><option data-ng-repeat="t in territories" value="TZ" >United Republic of Tanzania (TZ)</option><option data-ng-repeat="t in territories" value="US" >United States (US)</option><option data-ng-repeat="t in territories" value="VN" >Vietnam (VN)</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="ws-3">
                                    <a className="btn icon-btn edit mb mll mtll" data-ng-click="getAmazonReports(selectReport, selectTerritory, checkDate);">
                                        <span data-ng-hide="balanceDetails.length &gt; 0"><i className="icon-search1"></i> Check</span>
                                        <span data-ng-show="balanceDetails.length &gt; 0" ><i className="icon-reload"></i> Refresh</span>
                                    </a>
                                </div>
                            </form>
                        </div>
                        <div className="row-fluid">
                            <div className="table-responsive_big">


                                {
                                    checkInvData && <div className="alert alert-info">No data found for this month</div>
                                }
                                {
                                    checkInvData && <div className="alert alert-info">Please select a month, a report and a territory</div>
                                }
                                {
                                    checkInvData && <div className="alert alert-info">Export is in progress</div>
                                }
                                {
                                    checkInvData && <div className="alert alert-info">Data has successfully been deleted</div>
                                }
                                <table className="table " data-ng-show="amazonReport.length &gt; 0">
                                    <thead>
                                        <tr>
                                            <th>Territory Code</th>
                                            <th>Currency</th>
                                            <th>Year &amp; Month</th>


                                        </tr>
                                    </thead>
                                    <tbody>

                                    </tbody>
                                </table>
                            </div >
                        </div >
                        <div className="box-footer " data-ng-show="amazonReport.length &gt; 0 ; !getChkReportDsply">
                            <div className="verticalMediumWide hover-box text-center pull-left m0">
                                <ul className="hover-block textboxDropdownList full-width">
                                    <li className="hover-box">
                                        <div className="box-content">
                                            <div className="row-fluid">
                                                <div className="box box-primary ws-1 ms text-center iconLogo" ng-click="logout()">
                                                    <i className="icon-user gradientBlueFade"></i>
                                                    <span className="ws-12 m0">Logout</span>
                                                </div>
                                                <div className="box box-primary ws-1 ms text-center iconLogo">
                                                    <i className="icon-user gradientBlueFade"></i>
                                                    <span className="ws-12 m0 ">Rehaan Khodabocus</span>
                                                </div>
                                                <div className="box box-primary ws-1 ms text-center iconLogo">
                                                    <i className="icon-params gradientBlueFade"></i>
                                                    <span className="ws-12 m0">User Settings</span>
                                                </div>
                                                <div className="box box-primary span2 ms text-center iconLogo">
                                                    <i className="icon-megaphone gradientBlueFade"></i>
                                                    <span className="ws-12 m0">Notifications</span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="hover-box pull-right mts">
                                <button className="btn-warning "><i className="icon-plus1-circle"></i> Generate Invoice</button>
                                <div className="hover-block">

                                </div>
                            </div>
 
                            <a className="icon-btn info mt" data-ng-click="openSetCurrency()">
                                <i className="icon-plus1"></i> Set Currency
                            </a>
                            <a className="btn icon-btn edit mt " data-ng-click="reportExport(selectedReport)" data-ng-show="selectTerritory == 'All'">
                                <i className="icon-file-add"></i> Export Data
                            </a>
                            <a className="btn icon-btn delete mt " data-ng-click="deleteAmazonReports(checkDate, selectReport, selectTerritory)">
                                <i className="icon-close"></i> Delete Report
                            </a>
                        </div>
                    </div >
                    </>}
                </div >
            </div >

            {
                (() => {
                    if (fileUploadHistoryStatus) {
                        return <ViewUploadFileLogBox param={fileUploadHistoryStatus} ViewUploadFileLogClose={ViewUploadFileLogClose}/>
                    }
                })()
            }
        </div >
    );
}
